var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-form-group",
        { attrs: { label: "Transformation type" } },
        [
          _c("Multiselect", {
            attrs: {
              options: _vm.filteredTransformationOptions,
              label: "text",
              "track-by": "value",
            },
            model: {
              value: _vm.selectedTransformationObj,
              callback: function ($$v) {
                _vm.selectedTransformationObj = $$v
              },
              expression: "selectedTransformationObj",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.disableForEmptyAvailable.includes(_vm.selectedTransformation)
        ? _c(
            "div",
            [
              _vm.selectedTransformation
                ? _c(
                    "b-form-group",
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          model: {
                            value: _vm.disableForEmpty,
                            callback: function ($$v) {
                              _vm.disableForEmpty = $$v
                            },
                            expression: "disableForEmpty",
                          },
                        },
                        [_vm._v("\n        Disable for empty value\n      ")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedTransformation && !_vm.disableForEmpty
                ? _c(
                    "b-form-group",
                    { attrs: { label: "Fallback text" } },
                    [
                      _c("b-form-input", {
                        attrs: {
                          type: "text",
                          placeholder: "Text if value is empty",
                        },
                        model: {
                          value: _vm.emptyText,
                          callback: function ($$v) {
                            _vm.emptyText = $$v
                          },
                          expression: "emptyText",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.ignoreHtmlTagsIsVisible
        ? _c(
            "b-form-group",
            [
              _c(
                "b-form-checkbox",
                {
                  model: {
                    value: _vm.ignoreLineBreaks,
                    callback: function ($$v) {
                      _vm.ignoreLineBreaks = $$v
                    },
                    expression: "ignoreLineBreaks",
                  },
                },
                [_vm._v("\n      Also ignore Line Breaks\n    ")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedTransformation === "split-field-by-space"
        ? _c(
            "b-form-group",
            { attrs: { label: "Select fields to split by space" } },
            [
              _c("Multiselect", {
                attrs: { options: _vm.templateFields, multiple: true },
                model: {
                  value: _vm.splitBySpaceFields,
                  callback: function ($$v) {
                    _vm.splitBySpaceFields = $$v
                  },
                  expression: "splitBySpaceFields",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.cropToImageIsVisible
        ? _c(
            "b-form-group",
            { attrs: { label: "Percentage" } },
            [
              _c("b-form-input", {
                attrs: {
                  type: "number",
                  min: "0",
                  max: "100",
                  step: "1",
                  placeholder: "Crop percentage",
                },
                model: {
                  value: _vm.cropPercentage,
                  callback: function ($$v) {
                    _vm.cropPercentage = $$v
                  },
                  expression: "cropPercentage",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.rotateToWiderSideIsVisible
        ? _c(
            "div",
            [
              _c(
                "b-form-group",
                { attrs: { label: "Rotate image only if field matches" } },
                [
                  _c("b-form-select", {
                    attrs: { options: _vm.rotateConditionFieldOptions },
                    model: {
                      value: _vm.rotateConditionField,
                      callback: function ($$v) {
                        _vm.rotateConditionField = $$v
                      },
                      expression: "rotateConditionField",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.rotateConditionField
                ? _c(
                    "b-form-group",
                    { attrs: { label: "Matching value" } },
                    [
                      _c("b-form-input", {
                        attrs: { type: "text", placeholder: "Value" },
                        model: {
                          value: _vm.rotateConditionValue,
                          callback: function ($$v) {
                            _vm.rotateConditionValue = $$v
                          },
                          expression: "rotateConditionValue",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedTransformation === "download-image-from-box"
        ? _c(
            "b-form-group",
            {
              attrs: {
                label: "Box folder ID",
                description: "Leave empty to search the Box root folder.",
              },
            },
            [
              _c("b-form-input", {
                attrs: { type: "text", placeholder: "Box folder ID" },
                model: {
                  value: _vm.boxFolderId,
                  callback: function ($$v) {
                    _vm.boxFolderId = $$v
                  },
                  expression: "boxFolderId",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedTransformation === "columns-concatenation" ||
      _vm.selectedTransformation === "concatenate"
        ? _c(
            "div",
            [
              _c(
                "b-form-group",
                { attrs: { label: "Concatenation sequence" } },
                [
                  !_vm.concatenationSequence.length
                    ? _c("div", { staticClass: "text-muted small mb-2" }, [
                        _vm._v(
                          "\n        Add fields or strings to build the sequence.\n      "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.concatenationSequence, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: `concatenation-item-${index}`,
                        staticClass: "d-flex align-items-center mb-2",
                      },
                      [
                        _c("span", { staticClass: "mr-2" }, [
                          _vm._v(_vm._s(index + 1) + "."),
                        ]),
                        _vm._v(" "),
                        item.type === "field"
                          ? _c("b-form-select", {
                              staticClass: "mr-2",
                              attrs: { options: _vm.concatenationFieldOptions },
                              model: {
                                value: item.value,
                                callback: function ($$v) {
                                  _vm.$set(item, "value", $$v)
                                },
                                expression: "item.value",
                              },
                            })
                          : _c("b-form-input", {
                              staticClass: "mr-2",
                              attrs: {
                                type: "text",
                                placeholder:
                                  "Text to insert (new line: \\n or \\newline)",
                              },
                              model: {
                                value: item.value,
                                callback: function ($$v) {
                                  _vm.$set(item, "value", $$v)
                                },
                                expression: "item.value",
                              },
                            }),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            attrs: { size: "sm", variant: "outline-danger" },
                            on: {
                              click: function ($event) {
                                return _vm.removeConcatenationItem(index)
                              },
                            },
                          },
                          [_vm._v("\n          Remove\n        ")]
                        ),
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex flex-wrap align-items-end" },
                    [
                      _c(
                        "div",
                        { staticClass: "mr-2 mb-2" },
                        [
                          _c("b-form-select", {
                            staticStyle: { "min-width": "200px" },
                            attrs: { options: _vm.concatenationFieldOptions },
                            model: {
                              value: _vm.concatenationFieldToAdd,
                              callback: function ($$v) {
                                _vm.concatenationFieldToAdd = $$v
                              },
                              expression: "concatenationFieldToAdd",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "mr-2 mb-2",
                          attrs: { variant: "primary" },
                          on: { click: _vm.addConcatenationField },
                        },
                        [_vm._v("\n          Add field\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "mb-2",
                          attrs: { variant: "secondary" },
                          on: { click: _vm.addConcatenationString },
                        },
                        [_vm._v("\n          Add string\n        ")]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedTransformation === "values-to-header"
        ? _c(
            "div",
            [
              _c("b-form-group", { attrs: { label: "Map value to header" } }, [
                _c(
                  "div",
                  { staticClass: "text-muted small mb-2" },
                  [
                    _vm._v(
                      "\n        Select the field that will be mapped to the header (use %s as placeholder on the header name)\n        "
                    ),
                    _c("b-form-select", {
                      staticStyle: { "min-width": "200px" },
                      attrs: { options: _vm.concatenationFieldOptions },
                      model: {
                        value: _vm.valueFieldToAdd,
                        callback: function ($$v) {
                          _vm.valueFieldToAdd = $$v
                        },
                        expression: "valueFieldToAdd",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedTransformation === "columns-multiplier" ||
      _vm.selectedTransformation === "multiplier"
        ? _c(
            "b-form-group",
            { attrs: { label: "Select columns to multiply" } },
            [
              _c("Multiselect", {
                attrs: { options: _vm.xlsxHeaders, multiple: true },
                model: {
                  value: _vm.headersToMultiply,
                  callback: function ($$v) {
                    _vm.headersToMultiply = $$v
                  },
                  expression: "headersToMultiply",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedTransformation === "format"
        ? _c(
            "div",
            [
              _c(
                "b-form-group",
                { attrs: { label: "Format field value" } },
                [
                  _c("b-form-select", {
                    attrs: { options: _vm.formatOptions },
                    model: {
                      value: _vm.formatField,
                      callback: function ($$v) {
                        _vm.formatField = $$v
                      },
                      expression: "formatField",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.formatField === "thousand_separator"
                ? _c(
                    "b-form-group",
                    { attrs: { label: "Thousand separator symbol" } },
                    [
                      _c("b-form-input", {
                        attrs: {
                          type: "text",
                          placeholder: "Thousand separator (e.g., , or .)",
                          maxlength: "1",
                        },
                        model: {
                          value: _vm.thousandSeparator,
                          callback: function ($$v) {
                            _vm.thousandSeparator = $$v
                          },
                          expression: "thousandSeparator",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.productDescriptionIsVisible
        ? _c(
            "b-form-group",
            { attrs: { label: "Output words" } },
            [
              _c("b-form-input", {
                attrs: { type: "number", placeholder: "Output words" },
                model: {
                  value: _vm.outputWords,
                  callback: function ($$v) {
                    _vm.outputWords = $$v
                  },
                  expression: "outputWords",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.htmlListToCommaSeparatedValuesIsVisible
        ? _c(
            "b-form-group",
            { attrs: { label: "Delimiter character" } },
            [
              _c("b-form-input", {
                attrs: {
                  type: "text",
                  placeholder: "Delimiter character (default: ,)",
                },
                model: {
                  value: _vm.htmlListDelimiter,
                  callback: function ($$v) {
                    _vm.htmlListDelimiter = $$v
                  },
                  expression: "htmlListDelimiter",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.htmlListToCommaSeparatedValuesIsVisible
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "8" } },
                [
                  _c(
                    "b-form-checkbox",
                    {
                      model: {
                        value: _vm.maximumNumberOfValuesEnabled,
                        callback: function ($$v) {
                          _vm.maximumNumberOfValuesEnabled = $$v
                        },
                        expression: "maximumNumberOfValuesEnabled",
                      },
                    },
                    [
                      _vm._v(
                        "\n        Set maximum number of values to use\n      "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "4" } },
                [
                  _vm.maximumNumberOfValuesEnabled
                    ? _c("b-form-input", {
                        attrs: {
                          type: "number",
                          placeholder: "Maximum number of values",
                        },
                        model: {
                          value: _vm.maximumNumberOfValues,
                          callback: function ($$v) {
                            _vm.maximumNumberOfValues = $$v
                          },
                          expression: "maximumNumberOfValues",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.formSelectSeparatorIsVisible
        ? _c(
            "b-form-group",
            { attrs: { label: "Delimiter character" } },
            [
              _c("b-form-input", {
                attrs: { type: "text", placeholder: "Delimiter character" },
                model: {
                  value: _vm.delimiterCharacter,
                  callback: function ($$v) {
                    _vm.delimiterCharacter = $$v
                  },
                  expression: "delimiterCharacter",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.formSelectCharacterIsVisible
        ? _c(
            "b-form-group",
            [
              _c(
                "b-form-checkbox",
                {
                  model: {
                    value: _vm.addLineBreakIfWidthExceeded,
                    callback: function ($$v) {
                      _vm.addLineBreakIfWidthExceeded = $$v
                    },
                    expression: "addLineBreakIfWidthExceeded",
                  },
                },
                [_vm._v("\n      Only if row width is exceeded\n    ")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.formSelectCharacterIsVisible
        ? _c(
            "b-form-group",
            { attrs: { label: "Character" } },
            [
              _c("b-form-input", {
                attrs: { type: "text", placeholder: "Enter the character" },
                model: {
                  value: _vm.lineBreakCharacter,
                  callback: function ($$v) {
                    _vm.lineBreakCharacter = $$v
                  },
                  expression: "lineBreakCharacter",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.formMapFieldBasedOnCharsCountIsVisible
        ? _c(
            "b-form-group",
            { attrs: { label: "Group ID" } },
            [
              _c("b-form-input", {
                attrs: { type: "number" },
                model: {
                  value: _vm.mapFieldBasedOnCharsCountGroupID,
                  callback: function ($$v) {
                    _vm.mapFieldBasedOnCharsCountGroupID = $$v
                  },
                  expression: "mapFieldBasedOnCharsCountGroupID",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.formSplitToRowsIsVisible
        ? _c(
            "b-form-group",
            { attrs: { label: "Columns count" } },
            [
              _c("b-form-input", {
                attrs: { type: "number", min: "2" },
                model: {
                  value: _vm.splitRowsColsCount,
                  callback: function ($$v) {
                    _vm.splitRowsColsCount = $$v
                  },
                  expression: "splitRowsColsCount",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.formSplitToRowsIsVisible
        ? _c(
            "b-form-group",
            [
              _c(
                "b-form-checkbox",
                {
                  model: {
                    value: _vm.splitRowsAlignBulletsHorizontally,
                    callback: function ($$v) {
                      _vm.splitRowsAlignBulletsHorizontally = $$v
                    },
                    expression: "splitRowsAlignBulletsHorizontally",
                  },
                },
                [_vm._v("\n      Align bullets horizontally\n    ")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.formSplitToRowsIsVisible
        ? _c(
            "b-form-group",
            { attrs: { label: "Sort bullets by number of characters" } },
            [
              _c("b-form-select", {
                attrs: {
                  options: [
                    { value: false, text: "Off" },
                    { value: "asc", text: "Ascending" },
                    { value: "desc", text: "Descending" },
                  ],
                },
                model: {
                  value: _vm.splitRowsSortByNumberOfCharacters,
                  callback: function ($$v) {
                    _vm.splitRowsSortByNumberOfCharacters = $$v
                  },
                  expression: "splitRowsSortByNumberOfCharacters",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.formSplitToRowsIsVisible
        ? _c(
            "b-form-group",
            {
              attrs: {
                label:
                  "Move bullets to next column if column height is exceeded",
              },
            },
            [
              _c("b-form-input", {
                attrs: {
                  type: "number",
                  min: "0",
                  step: "1",
                  placeholder: "Column height limit (px)",
                },
                model: {
                  value: _vm.splitRowsMoveBulletsToNextColumnIfHeightExceeded,
                  callback: function ($$v) {
                    _vm.splitRowsMoveBulletsToNextColumnIfHeightExceeded = $$v
                  },
                  expression:
                    "splitRowsMoveBulletsToNextColumnIfHeightExceeded",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.formSelectSubstringIsVisible
        ? _c(
            "b-form-group",
            { attrs: { label: "Text to add" } },
            [
              _c("b-form-input", {
                attrs: {
                  type: "text",
                  placeholder: "Enter the character/string to append/prepend",
                },
                model: {
                  value: _vm.substring,
                  callback: function ($$v) {
                    _vm.substring = $$v
                  },
                  expression: "substring",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.formSelectConfigurableBulletsIsVisible
        ? _c(
            "div",
            [
              _c(
                "b-form-group",
                [
                  _c("b-form-select", {
                    attrs: { options: _vm.bulletsOptions },
                    model: {
                      value: _vm.bulletsToAdd,
                      callback: function ($$v) {
                        _vm.bulletsToAdd = $$v
                      },
                      expression: "bulletsToAdd",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.addLineJumpIsVisible
                ? _c(
                    "b-form-group",
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass: "ml-3",
                          model: {
                            value: _vm.addLineJump,
                            callback: function ($$v) {
                              _vm.addLineJump = $$v
                            },
                            expression: "addLineJump",
                          },
                        },
                        [_vm._v("\n        Add line jump\n      ")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-form-group",
                [
                  _c(
                    "b-form-checkbox",
                    {
                      staticClass: "ml-3",
                      model: {
                        value: _vm.addSubsequentIndentation,
                        callback: function ($$v) {
                          _vm.addSubsequentIndentation = $$v
                        },
                        expression: "addSubsequentIndentation",
                      },
                    },
                    [
                      _vm._v(
                        "\n        Add subsequent lines indentation\n      "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.itemsMarginIsVisible
                ? _c(
                    "b-form-group",
                    { attrs: { label: "Margin between list items" } },
                    [
                      _c("b-form-input", {
                        attrs: { type: "number", min: "0" },
                        model: {
                          value: _vm.itemsMargin,
                          callback: function ($$v) {
                            _vm.itemsMargin = $$v
                          },
                          expression: "itemsMargin",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.sortValuesByCharacterCount
                ? _c(
                    "b-form-group",
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass: "ml-3",
                          model: {
                            value: _vm.sortValuesByCharacterCountParam,
                            callback: function ($$v) {
                              _vm.sortValuesByCharacterCountParam = $$v
                            },
                            expression: "sortValuesByCharacterCountParam",
                          },
                        },
                        [
                          _vm._v(
                            "\n        Sort values based on character count\n      "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.sortValuesByCharacterCount &&
              _vm.sortValuesByCharacterCountParam
                ? _c(
                    "b-form-group",
                    [
                      _c("b-form-select", {
                        staticClass: "ml-3",
                        staticStyle: { "max-width": "200px" },
                        attrs: { options: _vm.sortDirectionOptions },
                        model: {
                          value: _vm.sortValuesByCharacterCountDirection,
                          callback: function ($$v) {
                            _vm.sortValuesByCharacterCountDirection = $$v
                          },
                          expression: "sortValuesByCharacterCountDirection",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.customTextIsVisible
                ? _c(
                    "b-form-group",
                    { attrs: { label: "Custom text:" } },
                    [
                      _c("b-form-input", {
                        attrs: { type: "text" },
                        model: {
                          value: _vm.bulletsCustom,
                          callback: function ($$v) {
                            _vm.bulletsCustom = $$v
                          },
                          expression: "bulletsCustom",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  attrs: { label: "Bullet Color (#000001 to use text color):" },
                },
                [
                  _c("b-form-input", {
                    attrs: { type: "color", placeholder: "Bullet color" },
                    model: {
                      value: _vm.bulletColor,
                      callback: function ($$v) {
                        _vm.bulletColor = $$v
                      },
                      expression: "bulletColor",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.formCustomScriptIsVisible,
              expression: "formCustomScriptIsVisible",
            },
          ],
        },
        [
          _c(
            "b-form-group",
            [
              _c("b-form-select", {
                attrs: { options: _vm.savedScriptsOptions },
                model: {
                  value: _vm.transformationScript,
                  callback: function ($$v) {
                    _vm.transformationScript = $$v
                  },
                  expression: "transformationScript",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { attrs: { label: "Custom script" } },
            [
              !_vm.codeEditor
                ? _c("b-form-textarea", {
                    attrs: { value: _vm.customScript, rows: "10" },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", {
                ref: "customScriptCodeEditor",
                staticClass: "custom-script-code-editor",
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "primary" },
                  on: { click: _vm.testScript },
                },
                [_vm._v("\n        Test script\n      ")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: { variant: "primary" },
                  on: { click: _vm.saveScript },
                },
                [_vm._v("\n        Save script\n      ")]
              ),
              _vm._v(" "),
              _vm.transformationScript
                ? _c(
                    "b-button",
                    {
                      attrs: { variant: "danger" },
                      on: { click: _vm.deleteScript },
                    },
                    [_vm._v("\n        Delete script\n      ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.customScriptOutputVisible,
                  expression: "customScriptOutputVisible",
                },
              ],
              staticClass: "card custom-script-output",
            },
            [
              _c("div", { staticClass: "card-header" }, [
                _vm._v("\n        Output:\n      "),
              ]),
              _vm._v(" "),
              _c("div", {
                ref: "customScriptOutput",
                staticClass: "card-body",
                staticStyle: { "white-space": "pre-wrap" },
              }),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.replaceEmptyValuesIsVisible
        ? _c(
            "div",
            [
              _c(
                "b-form-group",
                { attrs: { label: "Replacement" } },
                [
                  _c("b-form-input", {
                    attrs: { type: "text", placeholder: "Replacement text" },
                    model: {
                      value: _vm.replaceEmptyValuesText,
                      callback: function ($$v) {
                        _vm.replaceEmptyValuesText = $$v
                      },
                      expression: "replaceEmptyValuesText",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                { attrs: { label: "Field" } },
                [
                  _c("b-form-select", {
                    attrs: { options: _vm.xlsxHeaders },
                    model: {
                      value: _vm.replaceEmptyValuesField,
                      callback: function ($$v) {
                        _vm.replaceEmptyValuesField = $$v
                      },
                      expression: "replaceEmptyValuesField",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.replaceFractionsWithGlyphIsVisible
        ? _c(
            "div",
            [
              _c(
                "b-form-group",
                { attrs: { label: "Field" } },
                [
                  _c("b-form-select", {
                    attrs: { options: _vm.xlsxHeaders },
                    model: {
                      value: _vm.replaceFractionsWithGlyphField,
                      callback: function ($$v) {
                        _vm.replaceFractionsWithGlyphField = $$v
                      },
                      expression: "replaceFractionsWithGlyphField",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.emptyWhenRelatedFieldIsEmptyIsVisible
        ? _c(
            "div",
            [
              _c(
                "b-form-group",
                { attrs: { label: "Field" } },
                [
                  _c("b-form-select", {
                    attrs: { options: _vm.templateFields, multiple: false },
                    model: {
                      value: _vm.emptyRelatedFieldName,
                      callback: function ($$v) {
                        _vm.emptyRelatedFieldName = $$v
                      },
                      expression: "emptyRelatedFieldName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.conditionalValuesIsVisible
        ? _c(
            "b-card",
            { staticClass: "mb-3", attrs: { "body-class": "p-3" } },
            [
              _c(
                "b-row",
                { staticClass: "align-items-center mb-3" },
                [
                  _c("b-col", { attrs: { cols: "auto" } }, [
                    _c("span", [_vm._v("If: ")]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "conditional-values-if-col" },
                    [
                      _vm.conditionalValuesUsesTableColumns
                        ? _c("Multiselect", {
                            attrs: {
                              options: _vm.tableColumnOptions,
                              label: "text",
                              "track-by": "value",
                            },
                            model: {
                              value: _vm.selectedTableColumnObj,
                              callback: function ($$v) {
                                _vm.selectedTableColumnObj = $$v
                              },
                              expression: "selectedTableColumnObj",
                            },
                          })
                        : _c("Multiselect", {
                            attrs: {
                              options: _vm.xlsxHeaders,
                              multiple: false,
                            },
                            model: {
                              value: _vm.selectedColumn,
                              callback: function ($$v) {
                                _vm.selectedColumn = $$v
                              },
                              expression: "selectedColumn",
                            },
                          }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c("b-form-select", {
                        attrs: {
                          options: [
                            { value: "=", text: "Equals" },
                            { value: "!=", text: "Does not equal" },
                            { value: "empty", text: "Is Empty" },
                            { value: "not_empty", text: "Not Empty" },
                          ],
                        },
                        model: {
                          value: _vm.selectedCondition,
                          callback: function ($$v) {
                            _vm.selectedCondition = $$v
                          },
                          expression: "selectedCondition",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.conditionIsEmptiness
                    ? [
                        _c("b-col", { attrs: { cols: "auto" } }, [
                          _vm._v("\n          To:\n        "),
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c("b-form-input", {
                              attrs: { type: "text", placeholder: "Value" },
                              model: {
                                value: _vm.conditionValue,
                                callback: function ($$v) {
                                  _vm.conditionValue = $$v
                                },
                                expression: "conditionValue",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "align-items-center" },
                [
                  _c("b-col", { attrs: { cols: "auto" } }, [
                    _c("span", [_vm._v("Then change it to: ")]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c("b-form-input", {
                        attrs: { type: "text", placeholder: "New value" },
                        model: {
                          value: _vm.newValue,
                          callback: function ($$v) {
                            _vm.newValue = $$v
                          },
                          expression: "newValue",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.renameHeadersIsVisible
        ? _c("div", [
            _vm.renameHeadersHeaders.length
              ? _c("div", { staticClass: "table-responsive" }, [
                  _c("table", { staticClass: "table table-sm mb-0" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.renameHeadersHeaders, function (header) {
                        return _c("tr", { key: header }, [
                          _c("td", { staticClass: "align-middle" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(header) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              _c("b-form-input", {
                                attrs: {
                                  value: _vm.headerRenames[header] || "",
                                  type: "text",
                                  placeholder: "Keep original",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.setHeaderRename(header, $event)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      }),
                      0
                    ),
                  ]),
                ])
              : _c("div", { staticClass: "text-muted small" }, [
                  _vm._v("\n      No headers available.\n    "),
                ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Headers")]),
        _vm._v(" "),
        _c("th", [_vm._v("New header name")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }